module.exports = __webpack_public_path__ + "static/img/thank-you.1a28277.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/userStar/thank-you.svg
// module id = xcju
// module chunks = 1